import { useEffect, useRef, useState } from 'react';
import { notifications } from '@mantine/notifications';
import type { AttendanceShiftView, EmployeeDepartment } from 'shared-models/browser';
import { attendanceService } from '../../../../services/attendance/attendance.service';

export type AttendanceDepartmentCorrectionProps = {
  shift: AttendanceShiftView | null; departments: EmployeeDepartment[]; tenantId: string; employeeSession: string;
  onClose: () => void;
};

export function useAttendanceDepartmentCorrection({ shift, departments, tenantId, employeeSession, onClose }: AttendanceDepartmentCorrectionProps) {
  const [departmentName, setDepartmentName] = useState<string | null>(null);
  const [updateShiftSalary, setUpdateShiftSalary] = useState(false);
  const [updateProfile, setUpdateProfile] = useState(false);
  const [profileSalary, setProfileSalary] = useState<number | ''>('');
  const [profileBaseline, setProfileBaseline] = useState<number | null>(null);
  const [saving, setSaving] = useState(false);
  const inFlight = useRef(false);
  useEffect(() => {
    setDepartmentName(shift?.departmentName ?? 'כללי');
    setUpdateShiftSalary(false); setUpdateProfile(false); setProfileSalary('');
  }, [shift]);
  const assignment = departments.find((department) => department.name === departmentName);
  const selectDepartment = (name: string | null) => {
    setDepartmentName(name); setUpdateProfile(false); setProfileSalary('');
  };
  const toggleProfile = (enabled: boolean) => {
    setUpdateProfile(enabled); setProfileSalary(assignment?.hourlySalary ?? ''); setProfileBaseline(assignment?.hourlySalary ?? null);
  };
  const close = () => { if (!inFlight.current) onClose(); };
  const save = async () => {
    if (!shift?.clockInActionId || !shift.updatedAt || !assignment || inFlight.current || (updateProfile && profileSalary === '')) return;
    const profileChanged = updateProfile && profileSalary !== '' && profileSalary !== profileBaseline;
    if (departmentName === (shift.departmentName ?? 'כללי') && !updateShiftSalary && !profileChanged) { onClose(); return; }
    inFlight.current = true; setSaving(true);
    try {
      await attendanceService.correctShiftDepartment(tenantId, employeeSession, {
        employeeId: shift.employeeId, clockInActionId: shift.clockInActionId, departmentName: assignment.name,
        updateShiftSalary, expectedUpdatedAt: shift.updatedAt,
        ...(profileChanged ? { profileHourlySalary: profileSalary, expectedProfileHourlySalary: profileBaseline } : {}),
      });
      onClose();
    } catch (error) {
      notifications.show({ color: 'red', title: 'נוכחות', message: error instanceof Error ? error.message : 'עדכון המחלקה נכשל' });
    } finally { inFlight.current = false; setSaving(false); }
  };
  return { departmentName, updateShiftSalary, setUpdateShiftSalary, updateProfile, profileSalary, setProfileSalary, saving, assignment, selectDepartment, toggleProfile, close, save };
}